import React from 'react';
import PropTypes from 'prop-types';

import {
  ConfirmModal,
} from '../../../../components';

const DeleteEvent = ({
  isOpen,
  isPending,
  onCloseModal,
  event,
  onDelete,
}) => (
  <ConfirmModal
    isOpen={isOpen}
    isPending={isPending}
    actionTitle="Delete"
    onAction={onDelete}
    onClose={onCloseModal}
    title="Delete event"
  >
    <span className="text-size--sm">
      Are you sure you want to delete a event
      {' '}
      <b>{event.title}</b>
?
    </span>
  </ConfirmModal>
);

DeleteEvent.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  event: PropTypes.instanceOf(Object).isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DeleteEvent;
